import { Dispatch } from 'redux';

import { fetcher } from '../../lib/request';

import { City } from '../../models/Afisha/City';

const AFISHA_HOST = process.env.REACT_APP_AFISHA_HOST;
const AFISHA_KEY = process.env.REACT_APP_AFISHA_KEY;

export const SET_CITY = 'AFISHA_SET_CITY';

export const GET_CITIES_REQUEST = 'AFISHA_GET_CITIES_REQUEST';
export const GET_CITIES_RESPONSE = 'AFISHA_GET_CITIES_RESPONSE';
export const GET_CITIES_ERROR = 'AFISHA_GET_CITIES_ERROR';

export const GET_CITY_REQUEST = 'AFISHA_GET_CITY_REQUEST';
export const GET_CITY_RESPONSE = 'AFISHA_GET_CITY_RESPONSE';
export const GET_CITY_ERROR = 'AFISHA_GET_CITY_ERROR';

export const SET_CITY_VALUE = 'AFISHA_SET_CITY_VALUE';

interface CitiesResponse {
    result: City[];
    error: any;
}

export const setCityAction = (city: City) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_CITY,
    city,
});

export const getCitiesAction = (q = '', tariffId: number, lang: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_CITIES_REQUEST,
    });

    try {
        if (!lang) {
            lang = 'ru';
        }

        const response = await fetcher<CitiesResponse>(`${AFISHA_HOST}/api/v3/cities?${q ? `q=${q}` : ''}`
            + `&tariff_id=${tariffId}&lang=${lang}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        dispatch({
            type: GET_CITIES_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: GET_CITIES_ERROR,
            error,
        });
    }
};

export const setCityInputAction = (newValue: string) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_CITY_VALUE,
    newValue,
});

export const setCityIdAction = (id: string, lang: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_CITY_REQUEST,
    });

    try {
        if (!lang) {
            lang = 'ru';
        }

        const response = await fetcher(`${AFISHA_HOST}/api/v3/cities/${id}?lang=${lang}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        dispatch({
            type: GET_CITY_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: GET_CITY_ERROR,
            error,
        });
    }
};

export const setDefaultCityAction = (tariffId: number, lang: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_CITY_REQUEST,
    });

    try {
        const response = await fetcher<CitiesResponse>(`${AFISHA_HOST}/api/v3/cities?tariff_id=${tariffId}&lang=${lang}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        const capital = response.result.filter(city => city.is_capital)[0];

        dispatch({
            type: GET_CITY_RESPONSE,
            response: {
                result: capital ? capital : response.result[0],
            },
        });
    } catch (error) {
        dispatch({
            type: GET_CITY_ERROR,
            error,
        });
    }
};



// WEBPACK FOOTER //
// ./src/actions/Afisha/cities.ts